import moment from "moment";
import React, { useEffect } from "react";
import DocumentTitle from "react-document-title";
import { useHistory } from "react-router";
import Auth from "../../Auth/Auth";
import scrollToTop from "../../utils/scrollToTop";
import * as E from "../Elements/ElementStyles";
import { Separator } from "office-ui-fabric-react/lib/Separator";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { SignatureComponent } from "../../components/Signature/SignatureComponent";
import ModalElementSigned from "./ModalElementSigned";
import ElementsService, { SignatureContractElements } from "../../services/ElementsService";
import { setSavingsPlanElementsStatus } from "../../store/auth/actions";
import { useDispatch } from "react-redux";
import { ISignature } from "../../services/SignaturesService";
import TicketSupport from "../../components/TicketSupport/TicketSupport";
import { TicketSupportContainer } from "../../components/TicketSupport/TicketSupport.style";
import { ScreenStepType } from "../../components/TicketSupport/TicketSupportConstants";
import { TicketSupportError } from "../../services/TicketSupportService";
import useTicketSupport from "../../hooks/useTicketSupport";

const ElementSignatureConfirm = (props: any) =>
{
    const history = useHistory();
    const activePlan = Auth.getActivePlan();
    const [modalShow, setModalShow] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [signatures, setSignatures] = React.useState<SignatureContractElements[]>([]);
    const [phoneNumbers, setPhoneNumbers] = React.useState<string>("");
    const dispatch = useDispatch();

    const [ticketError, setTicketError] = React.useState<TicketSupportError>(
    {
        status: false,
        message: "",
    });

    const ticketSupport = useTicketSupport(
    {
        component: "ElementSignatureConfirm",
        screenName: ScreenStepType.FirmaContratoElements,
        ticketError,
        savingPlanId: activePlan.id,
    });

    React.useEffect(() =>
    {
        scrollToTop();
    }, []);

    React.useEffect(() =>
    {
        if(signatures.length === 0)
        {
            ElementsService.createElementAmount(activePlan.id).then((signatures: SignatureContractElements[]) =>
            {
                setSignatures(signatures);
                setIsLoaded(true);
            })
            .catch((error) =>
            {
                const backendMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    "Ha ocurrido un error al obtener las firmas.";
                ticketSupport.setShowSupportForm(true);
                setTicketError(
                {
                    status: true,
                    message: backendMessage,
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signatures, activePlan.id, modalShow]);

    const processExpirationDate = (signs: SignatureContractElements[]) =>
    {
        if(signs !== undefined && signs.length > 0)
        {
            // eslint-disable-next-line array-callback-return
            signs.map((signature: SignatureContractElements) =>
            {
                if(signature && typeof signature.expiresAt === "string")
                {
                    signature.expiresAt = moment(signature.expiresAt).toDate();
                }
            });
        }
    };

    useEffect(() =>
    {
        if(signatures !== undefined)
        {
            setPhoneNumbers(signatures.map((signature: SignatureContractElements) =>
                signature.phone === undefined ? "" : "X".repeat(signature.phone.length - 3) +
                signature.phone.slice(signature.phone.length - 3, signature.phone.length))
                .join(", ")
            );
        }
    }, [signatures]);

    const handleSubmit = async () =>
    {
        if(signatures.length > 0 || !modalShow)
        {
            await dispatch(setSavingsPlanElementsStatus(activePlan.id));
            scrollToTop();
            setModalShow(true);
        }
    };

    const handleError = (error: any) =>
    {
        const message =
            error?.response?.data?.message ||
            error?.message ||
            JSON.stringify(error, Object.getOwnPropertyNames(error), 2) ||
            "Ha ocurrido un error inesperado.";

        setTicketError({ status: false, message });
        ticketSupport.setShowSupportForm(true);
    };

    return(
        <>
            {/* Soporte */}
            <TicketSupportContainer>
                <TicketSupport {...ticketSupport} />
            </TicketSupportContainer>
            <DocumentTitle title="IronIA - Elements - Firma de Contrato">
                <React.Fragment>
                    <E.HelperStyle />
                    <E.ContainerSignature>
                        <E.MainContainerSignature>
                            <h2 style={{ margin: 0, cursor: "default" }}>
                                Elements - Firma de Contrato
                            </h2>
                            <Separator />
                            {!isLoaded && <Spinner size={SpinnerSize.large} />}
                            {isLoaded &&
                            (
                                <SignatureComponent
                                    signatures={signatures as ISignature[]}
                                    alreadySignedText=" "
                                    submitButtonText="Firmar contrato"
                                    cancelButtonText="Volver"
                                    headerTextArea={
                                        "Introduce el código que te hemos enviado" +
                                        (signatures.length > 1
                                            ? ` a los números ${phoneNumbers} `
                                            : signatures.length === 1
                                                ? ` al número ${phoneNumbers} `
                                                : " ") +
                                        "por SMS para firmar el contrato."
                                    }
                                    backButtonText="Volver"
                                    onBackButtonClicked={() => history.push("/Elements/Signature")}
                                    onCancelButtonClicked={() => history.push("/Elements/Signature")}
                                    requestNewCodeButtonText="Recibir nuevo código"
                                    onNewCodeSended={(signatures: any) =>
                                    {
                                        processExpirationDate(signatures);
                                        setSignatures(signatures);
                                    }}
                                    onSignatureChanged={(signatures: any) =>
                                    {
                                        processExpirationDate(signatures);
                                        setSignatures(signatures);
                                    }}
                                    onSigned={handleSubmit}
                                    onError={handleError}
                                />
                            )}
                        </E.MainContainerSignature>
                    </E.ContainerSignature>
                    {modalShow && <ModalElementSigned setModalShow={setModalShow} />}
                </React.Fragment>
            </DocumentTitle>

        </>
    );
};

export default ElementSignatureConfirm;